export const CONTACT_PHONE_NUMBER = "+1 (669)588-5303";
export const CONTACT_EMAIL = "support@ikiai.org";
